/* Names for icon-only navigation, without changing the existing controllers. */
(() => {
  const menu = document.querySelector('[aria-controls="HoundMenuDrawer"]');
  if (menu) menu.setAttribute('aria-label', 'Open navigation');
  const close = document.querySelector('#HoundMenuDrawer .hound-drawer__close');
  if (close) close.setAttribute('aria-label', 'Close navigation');
})();

/* A responsive selected-size view must never substitute another size's data. */
(() => {
  function check(shell) {
    shell.querySelectorAll('.hfg').forEach(guide => {
      if (guide.closest('.hound-folio-fit-calculator')) return;
      const disclosure = document.createElement('details');
      disclosure.className = 'hound-folio-fit-calculator';
      const summary = document.createElement('summary');
      summary.textContent = 'Body fit guide';
      guide.before(disclosure);
      disclosure.append(summary, guide);
    });
    const selected = [...shell.querySelectorAll('input[type="radio"]:checked')]
      .find(input => /size/i.test(input.name));
    if (!selected) return;
    const size = selected.value.trim().toUpperCase();
    shell.querySelectorAll('.hfg[data-sizes]').forEach(guide => {
      const index = guide.dataset.sizes.split(',').map(s => s.trim().toUpperCase()).indexOf(size);
      if (index < 0) return;
      const label = guide.querySelector('[data-hfg-size]');
      if (label) label.textContent = size;
      guide.querySelectorAll('[data-values]').forEach(node => {
        const value = node.dataset.values.split(',')[index];
        if (value != null) node.textContent = value;
      });
    });
    shell.querySelectorAll('.hsd[data-sizes]').forEach(diagram => {
      const available = diagram.dataset.sizes.split(',').map(s => s.trim().toUpperCase());
      const missing = !available.includes(size);
      diagram.toggleAttribute('data-measurements-unavailable', missing);
      let notice = diagram.querySelector('.hound-measurement-unavailable');
      if (missing && !notice) {
        notice = document.createElement('p');
        notice.className = 'hound-measurement-unavailable';
        notice.setAttribute('role', 'status');
        diagram.append(notice);
      }
      if (notice) {
        notice.hidden = !missing;
        notice.textContent = missing ? `Measurements for size ${size} are not available yet.` : '';
      }
    });
  }
  function boot() {
    document.querySelectorAll('[data-hound-folio-live]').forEach(check);
    document.addEventListener('click', event => {
      const shell = event.target.closest('[data-hound-folio-live]');
      if (shell) requestAnimationFrame(() => check(shell));
    });
    document.addEventListener('change', event => {
      const shell = event.target.closest('[data-hound-folio-live]');
      if (shell) check(shell);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
